<template>
  <div class="node-attr">
    <el-form ref="nodeForm" label-width="80px" label-position="left" :model="node">
      <el-form-item label="节点名称:">
        <el-input v-model="node.name" @change="changeName" maxlength="20"></el-input>
      </el-form-item>
      <el-form-item v-if="node.id !== startNodeId && node.type==='userTask'" label="候选人:" class="candidate">
        <el-select :value="candidateType" @change="changeCandidateType">
          <el-option label="发起人" value="starter"></el-option>
          <el-option label="直属上级" value="superiors"></el-option>
          <el-option label="自定义" value="user"></el-option>
          <el-option label="来源控件" value="component"></el-option>
        </el-select>
        <label class="show-candidate"
               v-for="(candidate, index) in node.candidates"
               :key="candidate.targetId"
               :title="getCanditates"
               v-if="index < 5">{{candidate.name}}<label v-if="index===4">...</label></label>
        <el-button v-show="candidateType==='user'" @click="selectPerson('user')">选择</el-button>
        <el-button v-show="candidateType==='component'" @click="selectPerson('component')">选择</el-button>
      </el-form-item>
      <el-form-item label="节点按钮:" v-if="node.type==='userTask'">
        <el-row class="action">
          <template v-for="action in node.actions">
            <el-button :title="action.name" :key="action.id" v-if="buttonIndex !== action.id">
              <i class="el-icon-remove-outline" v-if="!(node.id === startNodeId&&action.type==='流转')"
                 @click.stop="removeButton(action.id)"></i>
              <label @dblclick="buttonClick(action, true)">{{action.name}}</label>
            </el-button>
          </template>
          <a v-if="node.actions.length<6" @click="buttonClick({}, false,node.id === startNodeId)"><i class="el-icon-plus"></i>
            添加按钮</a>
        </el-row>
      </el-form-item>
      <template v-if="node.id !== startNodeId && node.type==='userTask'">
        <el-form-item label="审批意见:" class="opinion-required-item">
          <el-switch v-model="node.approvalOpinion" @change="updateApprovalOpinion"></el-switch>
        </el-form-item>
        <el-form-item class="opinion-required-item" label="意见必填:">
          <el-checkbox v-model="node.approvalOpinionRequired" :disabled="node.approvalOpinion === false"></el-checkbox>
        </el-form-item>
        <el-form-item class="opinion-required-item approval-opinion-required" label-width="6px">
         <el-select v-show="node.approvalOpinionRequired"
                   class="opinion-required-select"
                   :value="getSelectButton"
                   @change="changeButton"
                   multiple collapse-tags clearable filterable placeholder="请选择">
          <el-option
            v-for="nodes in node.actions"
            :key="nodes.id"
            :label="nodes.name"
            :value="nodes.id">
          </el-option>
        </el-select>
        </el-form-item>
      </template>
      <template v-if="node.id === startNodeId && node.type==='userTask'">
        <el-form-item label="归档审批信息:" label-width="96px">
         <el-switch v-model="node.approvalOpinionArchive"></el-switch>
        </el-form-item>
      </template>
      <template v-else-if="node.id !== startNodeId && node.type==='userTask'">
       <div :class="countersignShow?'one':'more'" @click="changeOpenMore(node)">{{countersignShow?'收起':'更多设置'}} <i :class="countersignShow?'el-icon-arrow-up':'el-icon-arrow-down'"></i></div>
        <el-collapse-transition>
        <div v-show="countersignShow">
          <el-form-item label="归档审批信息:" label-width="96px">
          <el-switch v-model="node.approvalOpinionArchive"></el-switch>
          </el-form-item>
          <el-form-item class="opinion-required-item" label-width="96px" label="会签:" v-if="node.id !== startNodeId && node.type==='userTask'">
          <el-switch v-model="node.isCountersign" @change="changeCountersign"></el-switch>
          </el-form-item>
          <el-form-item v-if="node.isCountersign" label="请选择比例" class="opinion-required-item">
            <el-select v-model="node.countersignRatio" placeholder="请选择比例">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-tooltip class="tooltip" content="通过人数满足该比例的话，才能正常流转 否则此流程结束" placement="top">
                <span class="fa fa-question-circle"></span>
            </el-tooltip>
          </el-form-item>
          <el-form-item v-if="node.isCountersign" label="会签同意按钮" label-width="112px" prop="agreedActionId" :rules=" {required: true, message: '请选择', trigger: 'change'}">
            <el-select v-model="node.agreedActionId" placeholder="请选择">
              <el-option
                v-for="action in node.actions"
                :key="action.id"
                :label="action.name"
                :value="action.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="node.isCountersign" label="会签不同意按钮" label-width="112px" prop="disAgreedActionId" :rules=" {required: true, message: '请选择', trigger: 'change'}">
            <el-select v-model="node.disAgreedActionId" placeholder="请选择">
              <el-option
                v-for="action in node.actions"
                :key="action.id"
                :label="action.name"
                :value="action.id">
              </el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="当前节点审批人不与申请人一致" label-width="196px">
             <el-switch v-model="node.canSameAsStarter"></el-switch>
          </el-form-item>
        </div>
        </el-collapse-transition>
      </template>

    </el-form>
    <el-dialog
      class="edit-dialog"
      title="按钮设置"
      :visible.sync="editButtonDialog"
      width="392px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div class="edit-content">
        <el-form :model="button" label-width="90px" label-position="right" :rules="rules" ref="editForm">
          <el-form-item label="按钮名称" prop="name">
            <el-input v-model="button.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="按钮类型" prop="type">
            <el-select v-model="button.type" placeholder="请选择">
              <el-option label="流转" value="流转" v-if="button.nodeType==='normal'"></el-option>
              <el-option label="打印" value="打印"></el-option>
              <el-option label="自定义" value="自定义"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="button.type === '打印'" label="选择模板" prop="templateName">
            <el-select v-model="button.templateName" placeholder="请选择" filterable>
              <el-option
                v-for="item in templates"
                :key="item.id"
                :label="item.templateName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'NodeAttr',
  props: ['node', 'startNodeId'],
  inject: ['processService'],
  data () {
    let candidateType = ''
    if (this.node.candidates.length > 0) {
      switch (this.node.candidates[0].type) {
        case 'starter':
          candidateType = 'starter'
          break
        case 'superiors':
          candidateType = 'superiors'
          break
        case 'user':
        case 'group':
        case 'department':
          candidateType = 'user'
          break
        case 'component':
          candidateType = 'component'
          break
      }
    }
    return {
      buttonIndex: '',
      buttonName: '',
      dialogVisible: false,
      allPerson: [],
      selectedPerson: [],
      candidateType: candidateType,
      rules: {
        name: [{ required: true, message: '请输入按钮名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择按钮类型', trigger: 'change' }],
        templateName: [{ required: true, message: '请选择模板', trigger: 'change' }]
      },
      button: {
        nodeType: 'normal'
      },
      // 模板
      templates: [],
      editButtonDialog: false,
      countersignShow: false,
      options: [{
        value: 1,
        label: 1
      }, {
        value: 0.9,
        label: 0.9
      }, {
        value: 0.8,
        label: 0.8
      }, {
        value: 0.7,
        label: 0.7
      }, {
        value: 0.6,
        label: 0.6
      }, {
        value: 0.5,
        label: 0.5
      }, {
        value: 0.4,
        label: 0.4
      }, {
        value: 0.3,
        label: 0.3
      },
      {
        value: 0.2,
        label: 0.2
      }, {
        value: 0.1,
        label: 0.1
      }]
    }
  },
  watch: {
    'node.candidates' () {
      if (this.node && this.node.candidates.length > 0) {
        switch (this.node.candidates[0].type) {
          case 'starter':
            this.candidateType = 'starter'
            break
          case 'superiors':
            this.candidateType = 'superiors'
            break
          case 'user':
          case 'group':
          case 'department':
            this.candidateType = 'user'
            break
          case 'component':
            this.candidateType = 'component'
            break
        }
      }
    },
    'node.id' () {
      // 切换节点的时候，默认关闭
      this.countersignShow = false
    }
  },
  methods: {
    changeName (value) {
      this.processService.updateNodeName({
        'id': this.node.id,
        'name': value
      })
    },
    changeCandidateType (value) {
      this.processService.updateCandidateType({
        'id': this.node.id,
        'type': value
      })
    },
    addAction () {
      this.processService.addAction(this.node.id)
    },
    // 因为 按钮的修改和新增是两个不同的方法，需要区分一下
    buttonClick (action, isEdit, isStartNode) {
      let button = {...action}
      button.isEdit = isEdit
      if (isStartNode) {
        this.button.nodeType = 'startNode'
      } else {
        button.type = button.type || '流转'
      }
      this.button = {...button}
      this.editButtonDialog = true
    },
    removeButton (actionId) {
      this.processService.removeNodeAction({
        'nodeId': this.node.id,
        'actionId': actionId
      })
    },
    saveSelectPerson (param) {
      param.nodeId = this.node.id
      this._provided.processService.saveSelectPerson(param)
      this.dialogVisible = false
    },
    selectPerson (way) {
      this.$emit('selectPerson', {nodeId: this.node.id, way: way})
    },
    updateApprovalOpinion (state) {
      if (!state) {
        this.node.approvalOpinionRequired = false
      }
    },
    changeButton (val) {
      this.node.actions.forEach(action => {
        this.processService.updateNodeAction({
          'id': action.id,
          'nodeId': this.node.id,
          'requiredRequired': val.includes(action.id)
        })
      })
    },
    save () {
      this.$refs.editForm.validate(v => {
        if (v) {
          if (this.button.isEdit) {
            let params = {
              'id': this.button.id,
              'nodeId': this.node.id,
              'name': this.button.name,
              'type': this.button.type
            }
            if (this.button.type === '打印') {
              params.templateName = this.button.templateName
            }
            this.processService.updateNodeAction(params)
          } else {
            this.processService.addAction(this.node.id, {...this.button})
          }
          this.cancel()
        } else {
          return false
        }
      })
    },
    cancel () {
      this.button = {}
      this.$refs.editForm.clearValidate()
      this.editButtonDialog = false
    },
    nodeFormValidate () {
      return this.$refs.nodeForm.validate()
    },
    // 获取模板
    getTemplates () {
      let params = {
        index: 1,
        size: -1,
        filters: {
          templateName: '',
          paramType: '流程',
          definitionId: this.processService.processDefinition.id
        }
      }
      this.$axios.get('/system-api/printTemplate', { params }).then(({data}) => { this.templates = data.items || [] })
    },
    changeCountersign (val) {
    // 切换是否是会签节点
      if (val) {
        this.$confirm('', '会签节点不允许拖控件，有且仅有两条流转线，并且操作按钮不同，不允许有流转条件，是否继续操作?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          customClass: 'deleMessageBox',
          center: true
        }).then(() => {
          this.node.isCountersign = val
        }).catch(() => {
          this.node.isCountersign = !val
        })
      }
    },
    changeOpenMore (node) {
      this.countersignShow = !this.countersignShow
    }
  },
  computed: {
    getCanditates () {
      let title = ''
      this.node.candidates.forEach(m => {
        title += m.name + ' '
      })
      return title
    },
    getSelectButton () {
      let vals = []
      this.node.actions.forEach(item => {
        if (item.requiredRequired) {
          vals.push(item.id)
        }
      })
      return vals
    }
  },
  created () {
    this.getTemplates()
  }
}
</script>
<style lang="scss">
  .node-attr {
    .el-form {
      .one,.more{
        color: #BCBCBC;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
        margin-top: 10px;
        i {
          color: #BCBCBC;
        }
        &:hover{
          color: #54ABF1;
          i{
            color: #54ABF1;
          }
        }
        &:active{
          color: #1989fa;
          i{
            color: #1989fa;
          }
        }
      }
      .el-form-item {
        margin-top: 10px;
        margin-bottom: 0px;
        padding-left: 5px;
        .el-form-item__label {
          font-size: 12px;
        }
        .el-input {
          width: 170px;
          input {
            padding-left: 5px;
          }
        }
        .el-select {
          width: 98px;
          height: 24px;
          .el-input__icon {
            line-height: 25px;
          }
          .el-input {
            width: 100%;
            height: 100%;
            input {
              height: 100%;
            }
          }
        }
        .el-row {
          .el-input {
            width: 60px;
            height: 22px;
            > input {
              padding: 0 0 0 0;
              height: 100%;
              width: 40px;
            }
            .el-input-group__append {
              cursor: pointer;
              width: 20px;
              padding: 0 0 0 0;
              > i {
                color: #54ABF1;
              }
            }
          }
          > a {
            font-size: 12px;
            color: #54ABF1;
            cursor: pointer;
            position: relative;
            &:active {
              color: #388DD2;
            }
          }
          > div {
            margin-right: 15px;
          }
          .el-button {
            max-width: 60px;
            min-width: 38px;
            margin-right: 2px;
            padding: 4px 4px 4px 4px;
            position: relative;
            &:hover {
              .el-icon-remove-outline {
                display: block;
              }
            }
            .el-icon-remove-outline {
              position: absolute;
              position: absolute;
              right: -6px;
              top: -4px;
              line-height: 10px;
              color: #ff2a2a;
              display: none;
            }
            span {
              color: #54ABF1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              display: block;
              > label {
                font-size: 12px;
              }
            }
          }
        }
        .tooltip {
          margin-left: 20px;
        }
      }
      .el-form-item.opinion-required-item{
        display: inline-block;
      }
      .el-form-item.approval-opinion-required {
        width: 135px;
        height: 28px;
        margin-top: 0;
      }
     .el-select.opinion-required-select{
        display: inline-block;
        margin-left: 6px;
        width: 170px;
        height: 26px;
        .el-select__tags{
          width: 100%;
          >span{
            width: 100%;
          }
          .el-select__tags-text{
            max-width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .el-select__input.is-mini{
            display: none;
          }
        }
        .el-input.el-input--mini.el-input--suffix{
          .el-input__inner{
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
        span{
          font-size: 12px;
        }
      }
      .candidate {
        button {
          padding: 6px 4px 4px 4px;
          span {
            font-size: 12px;
            color: #54ABF1
          }
        }
        .show-candidate {
          margin-right: 12px;
          font-size: 12px;
        }
        .el-input__suffix {
          right: 0px;
          top: 3px;
        }
      }
    }

    .edit-dialog {
      .el-form {
        .el-form-item {
          &:not(:last-child) {
            margin-bottom: 18px;
          }
          .el-input, .el-select {
            width: 204px;
            height: 28px;
            .el-input__inner {
              width: 204px;
              height: 28px;
              border: 1px solid #C2C3C4;
              border-radius: 4px;
            }
          }
        }
      }

      .el-dialog__footer {
        padding-top: 0;

        .dialog-footer {
          .el-button+.el-button {
            margin-left: 50px;
            border: 1px solid #54ABF1;
            color: #54ABF1;

            &:hover,&:active,&:focus {
              background-color: #fff;
            }
          }
          .el-button {
            width:82px;
            height:26px;
            padding: 0;
            line-height: 26px;
            border-radius: 4px;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/process/design/process-node-attr.vue